/*
 * @format
 * @flow
 *
 * SingleClickButton.jsx
 * Created by Harold Rodriguez on 5/18/18.
 */
import React from 'react';
import type { Node } from 'react';

type PropTypes = {
    autoRecover: boolean,
    autoRecoverTime: number,
    buttonClass: string,
    children: Node,
    onClick: Function,
    recovered: boolean, // if the button is recovered from being disabled by click
    disabled: boolean   // if the button is disabled completely
};

type StateTypes = {
    disabled: boolean
};

export default class SingleClickButton extends React.Component<PropTypes, StateTypes> {
    static defaultProps = {
        autoRecover: false,
        disabled: false,
        autoRecoverTime: 5000,
        children: 'Submit',
        onClick: () => {},
        buttonClass: 'rec-button-primary'
    };

    state = {
        disabled: this.props.disabled
    };

    componentWillReceiveProps(nextProps: PropTypes) {
        if (nextProps.disabled !== this.props.disabled) {
            this.setState({ disabled: nextProps.disabled });
        }
        if (nextProps.recovered) {
            this.setState({ disabled: false });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    timeoutId: TimeoutID;

    handleClick = (e: SyntheticInputEvent<HTMLButtonElement>) => {
        if (!this.state.disabled) {
            this.setState({ disabled: true }, () => {
                this.props.onClick(e);
                if (this.props.autoRecover) {
                    this.timeoutId = setTimeout(() => {
                        this.setState({ disabled: false });
                    }, this.props.autoRecoverTime);
                }
            });
        }
    };

    render() {
        return (
            <button
                className={`rec-button-single-click ${this.props.buttonClass}`}
                disabled={this.state.disabled}
                onClick={this.handleClick}>
                {this.props.children}
            </button>
        );
    }
}
